export enum SignalRAction {
  ADDED = 'ADDED',
  UPDATED = 'UPDATED',
  DELETED = 'DELETED',
  NONE = 'NONE',
}
